import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useWebhookLogHttp } from '@/core/api/webhook-logs'
import { WebhookLog, WebhookLogPayload } from '@/core/models/webhook-log'

export type WebhookLogCollection = {
    data: Array<WebhookLog>,
    meta?: MetaPayload,
    links?: any
}

const state: WebhookLogCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const webhookLogCollection: Module<WebhookLogCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: WebhookLogCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: WebhookLogPayload) => {
                state.data.push(new WebhookLog(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useWebhookLogHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: WebhookLogCollection): WebhookLogCollection => {
            return state
        }
    }
}
